import { Field, ObjectType } from 'type-graphql'

@ObjectType()
export class ShippingOptionArgs {
  @Field(() => Boolean)
  skipCaching?: boolean
}
